import { Cancelled, Pace, RatingHighest, Report, Warning } from '@berlitz/icons'
import Attachment from '@berlitz/streamline-icons/lib/regular/01-Interface-Essential/27-Link-Unlink/Attachment'
import Notes from '@berlitz/streamline-icons/lib/regular/11-Content/01-Content-Creation/ContentPaperEdit'
import CounsellingRegButton from '@components/CounsellingRegButton'
import LessonRegButton, { TextLabel } from '@components/LessonRegButton'
import { LessonStatus } from '@components/ListCard'
import { Status, StyledIcon } from '@components/ListCard/style'
import Tooltip from '@components/Tooltip'
import WithLessonUtilsHOC, { WithLessonUtilsProp } from '@hocs/WithLessonUtils'
import { GroupClassListItem } from '@interfaces/MySchedule'
import { nonLessons } from '@utils/lesson-type'
import moment from 'moment'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { IndicatorsProp } from './interface'
import { CompletedTick, IndicatorCol, LessonBadge, StyledFirstClass } from './style'

const nlt = nonLessons.map((lesson) => lesson.toLowerCase())

const queryDateFormat = (val: string) => moment.utc(val, 'YYYY-MM-DD HH:mm:ss').format()

const Indicators: React.FC<IndicatorsProp & WithLessonUtilsProp> = ({
  warning = false,
  lessons = 0,
  firstLesson = false,
  highestRating = false,
  paceWarning = false,
  reportNeeded = false,
  attachment = [],
  notes,
  status = 'unknown',
  type = 'unknown',
  instructor,
  startDate,
  endDate,
  at,
  lessonRegistered,
  isCutOff,
  isAbsent,
  isBoD1,
  programId,
  studentId,
  sessionId,
  programType,
  lesson,
  hasStudent,
  setOpenFileModal,
  setAttachments,
  setNote,
  setOpenNoteModal,
  ...props
}) => {
  return (
    <>
      {warning && (
        <IndicatorCol>
          <Warning color="error" />
        </IndicatorCol>
      )}
      {firstLesson && (
        <IndicatorCol>
          <StyledFirstClass color="brand03" />
        </IndicatorCol>
      )}
      {highestRating && (
        <IndicatorCol>
          <RatingHighest />
        </IndicatorCol>
      )}
      {lessons >= 1 && (
        <IndicatorCol>
          <Tooltip
            message={
              <FormattedMessage
                id="{count, plural, zero {# none} one {# lesson left} other {# lessons left}}"
                defaultMessage="{count, plural, zero {# none} one {# lesson left} other {# lessons left}}"
                values={{ count: lessons }}
              />
            }
          >
            <LessonBadge>
              <span>{lessons}</span>
            </LessonBadge>
          </Tooltip>
        </IndicatorCol>
      )}
      {paceWarning && (
        <IndicatorCol>
          <Pace color="error" />
        </IndicatorCol>
      )}
      {reportNeeded && (
        <IndicatorCol>
          <Report color="error" />
        </IndicatorCol>
      )}
      {attachment?.length ? (
        <IndicatorCol
          onClick={() => {
            setOpenFileModal(true)
            setAttachments(attachment)
          }}
        >
          <Attachment color="brand06" />
        </IndicatorCol>
      ) : null}
      {!isBoD1 && notes ? (
        <IndicatorCol
          onClick={() => {
            setOpenNoteModal(true)
            setNote(notes)
          }}
        >
          <Notes color="brand06" />
        </IndicatorCol>
      ) : null}
      {['cancelled', 'rejected'].includes(status) && (
        <IndicatorCol>
          <LessonStatus status={status} />
        </IndicatorCol>
      )}

      {['confirmed', 'completed'].includes(status) && isAbsent && (
        <IndicatorCol>
          <Status cancelled>
            <FormattedMessage id="Absent" />
            <StyledIcon>
              <Cancelled color="brand03" />
            </StyledIcon>
          </Status>
        </IndicatorCol>
      )}

      {props.isGroup({ ProgramType: programType } as GroupClassListItem) &&
        lesson.SessionMetaData.CounsellingLesson && (
          <IndicatorCol>
            <CounsellingRegButton
              lesson={lesson.SessionMetaData.CounsellingLesson}
              url={`/instructors/scheduling/counselling-registration?id=${instructor}&sd=${queryDateFormat(
                lesson.SessionMetaData.CounsellingLesson.StartTime
              )}&ed=${queryDateFormat(lesson.SessionMetaData.CounsellingLesson.EndTime)}&at=${
                lesson.SessionMetaData.CounsellingLesson.SessionMetaData.Index
              }&back=instructors/scheduling/my-lessons`}
            />
          </IndicatorCol>
        )}

      {!hasStudent && (
        <IndicatorCol>
          <TextLabel>
            <FormattedMessage id="No students enrolled" />
          </TextLabel>
        </IndicatorCol>
      )}

      {!nlt.includes((type || '').toLowerCase()) && !isCutOff && hasStudent && (
        <IndicatorCol>
          <LessonRegButton
            type={type}
            url={`/instructors/scheduling/lesson-registration?id=${instructor}&sd=${startDate}&ed=${endDate}&at=${at}&back=instructors/scheduling/my-lessons&session=${sessionId}`}
          />
        </IndicatorCol>
      )}

      {status !== 'cancelled' && lessonRegistered && (
        <IndicatorCol>
          <CompletedTick color="brand02" />
        </IndicatorCol>
      )}
    </>
  )
}

export default WithLessonUtilsHOC(Indicators)
